// extracted by mini-css-extract-plugin
module.exports = {"CounterContainer":"TimeCounter_CounterContainer__2P_3u","TimeExpired":"TimeCounter_TimeExpired__fcygb","Counter":"TimeCounter_Counter__4qUua"};